// extracted by mini-css-extract-plugin
export default {"card":"PKV0IALZ","lift":"QU8RBHkP","header":"o73bGous","headerText":"k5u6AMuJ","eyebrow":"DVAhn1Zt","title":"njCQ0Hn2","action":"sts2RYcr","body":"YewKGqCw"};